import React, { useContext, useEffect, useState } from 'react';

import { createStyles, makeStyles, Theme, withStyles } from '@material-ui/core/styles';
import Confirm from '../../components/confirm';
import { AppContext } from '../../contexts/app-context';
import {
  apiRequestError, canJobWrite, canWritePendingEnrollment, getAppRoutePagePaths, triggerESPJobs
} from '../../utils/helper';
import { TriggerIcon } from '../../utils/icons';
import {
  Alert, AlertTitle, Badge, Box, IconButton, ListItemIcon, ListItemText, MenuItem, Tooltip,
  Typography
} from '../../utils/material-ui-core';
import SaveBackdrop from '../../components/saveBackdrop';


interface IJobRunButtonProps {
  jobName: string;
  mode: number;
  fileId: number;
}

const StyledMenuItem = withStyles((theme) => ({
  root: {
    "&:focus": {
      backgroundColor: theme.palette.secondary.main,
      "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
        color: theme.palette.common.white,
      },
    },
  },
}))(MenuItem);

const JobRunButton = ({ jobName, mode, fileId }: IJobRunButtonProps) => {
  const [triggerEnrollJobDialogOpen, setTriggerEnrollJobDialogOpen] = useState<boolean>(false);
  const [saveInProgress] = useState<boolean>(false);
  const pageStyles = LocalPageStyles();

  const { appRoutePaths, pendingEnrollmentCompanies, userFunctionAccess, showAlert, writeLog, refreshData } = useContext(AppContext);

  const [queueCount, setQueueCount] = useState<number>(0);
  const [inQueue, setInQueue] = useState<boolean>(false);


  // Get confirmation before trigger job to rund
  const triggerEnrollJobDialogConfirmation = async (confirm: boolean) => {
    setTriggerEnrollJobDialogOpen(false);

    if (confirm) {
      writeLog("Jobs Tab " + jobName, " Trigger file confirmation model closed (yes).", "", "job");
      setTriggerEnrollJobDialogOpen(true);
      await triggerJob();
      
      setTriggerEnrollJobDialogOpen(false);
    } else {
      writeLog("Jobs Tab " + jobName, " Trigger file confirmation model closed (no).", "", "job");
    }
  };

  const triggerJob = async () => {
    try {
      
      writeLog("Jobs Tab " + jobName, "User clicked 'Run job' button.", "", "");
      //const jobNameFilter= jobName.replace("Enrollment","Enrollment (New)");
      const jobPaths = getAppRoutePagePaths("Jobs & Log", appRoutePaths) as AppPagePath[];
      //const filterJobPaths = jobPaths.filter((jobPath) => jobPath.title.toLowerCase() === jobNameFilter.toLowerCase());
      const filterJobPaths = jobPaths.filter((jobPath) => jobPath.title.toLowerCase() === jobName.toLowerCase());

      if (filterJobPaths.length > 0) {
        const jobKey = filterJobPaths[0].key;

        writeLog("Jobs Tab " + jobName, "Update trigger file via api.", jobKey, "job");
     //setSaveInProgress(true);
        const apiResponse = await triggerESPJobs(jobKey, fileId);
        if (apiResponse.success) {
          writeLog("Jobs Tab " + jobName, "Job trigger file updated successfully.", jobKey, "job");
          showAlert({
            message: apiResponse.data.status.toString(),
            severity: "success",
          });
          refreshData("espjob");
          //setSaveInProgress(false);
        } else {
          writeLog("Jobs Tab " + jobName, "Error : Job trigger file update failed. " + apiResponse.errorMessage, jobKey, "job");
          showAlert({ message: apiResponse.errorMessage, severity: "error" });
        }
      }
    } catch (e) {
      writeLog("Jobs Tab " + jobName, "Error : Job trigger file update failed. Something went wrong in our system.", "", "");
      //setSaveInProgress(false);
      showAlert({
        message: apiRequestError(e, "Something went wrong in our system."),
        severity: "error",
      });
    }
  };

  useEffect(() => {
    const initialPageAsync = async () => {
      setInQueue(false);
      setQueueCount(0);
      let totalInQueue = 0;

      if (pendingEnrollmentCompanies != null && pendingEnrollmentCompanies.length > 0) {
        totalInQueue = pendingEnrollmentCompanies
          .map(function (pendingEnrollmentCompanie) {
            return pendingEnrollmentCompanie.inQueueCount;
          })
          .reduce(function (totalCount, count) {
            return totalCount + count;
          });
      }

      if (totalInQueue > 0) {
        setQueueCount(totalInQueue);
      }

      if (fileId > 0 || totalInQueue > 0) {
        setInQueue(true);
      }
    };

    initialPageAsync();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pendingEnrollmentCompanies, fileId]);

  return (
    <>
    <SaveBackdrop open={saveInProgress} />
    <Confirm title="Confirmation" content="Wish to trigger the batch job to run?" yesText="YES" noText="NO" open={triggerEnrollJobDialogOpen} callbackOnClose={() => setTriggerEnrollJobDialogOpen} callbackOnConfirm={triggerEnrollJobDialogConfirmation} />
      {canWritePendingEnrollment(userFunctionAccess) && canJobWrite(jobName.toLowerCase(), userFunctionAccess) && inQueue ? (
        <>
          {/* {mode === 0 ? (
            <IconButton>
              <Tooltip arrow title={"Run Job"} >
                <Badge badgeContent={queueCount} color="primary">
                  <TriggerIcon color="secondary" onClick={triggerJob} />
                </Badge>
              </Tooltip>
            </IconButton>
          ) : null} */}

          {/* {mode === 2 ? (
            <StyledMenuItem onClick={triggerJob}>
              <ListItemIcon>
                <TriggerIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary={"Trigger Job"} />
            </StyledMenuItem>
          ) : null} */}

          {/* {mode === 1 ? (
            <Box>
              <Alert severity="info">
                <AlertTitle> {`Some records are ready to process.`}</AlertTitle>
                <Box display="flex" justifyItems="center" alignItems="center" className={pageStyles.contentContainer}>
                  <Box>
                    <Typography variant="body2">
                      {canJobWrite(jobName.toLowerCase(), userFunctionAccess) ? "Press the `Run Job` button to process these registration accounts." : "Request IT/COM to process these registration accounts."}
                      &nbsp;&nbsp;
                    </Typography>
                  </Box>
                </Box>
              </Alert>
              <Box p={1}>&nbsp;</Box>
            </Box>
          ) : null} */}
        </>
      ) : null}
    </>
  );
};

const LocalPageStyles = makeStyles((theme: Theme) =>
  createStyles({
    contentContainer: {
      flexDirection: "row",
      [theme.breakpoints.down("sm")]: {
        flexDirection: "column",
      },
    },
  })
);

export default JobRunButton;
